import { themes } from '../../../data';

const themesFunc = (state = themes) => state;

export default themesFunc;